module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Pin #{nr}":"Pin #{nr}","Pin \\\\#{nr}":"Pin \\\\#{nr}"},"de":{"Pin #{nr}":"{nr}. Pin"}}')
  delete Component.options._Ctor
}
